<template>
    <FormCard>
        <template #cardTitle>
            PERSONAL INFORMATION
        </template>
        <template #cardSubtitle>
            The portion below is automatically filled-out by the system. If you think there are issues with these information, please contact HMI.
        </template>
        <template #cardText>
            <div v-show="getRelated && getRelated.PRIN_DEP && (getRelated.PRIN_DEP).length > 1">
                <v-alert
                    dense
                    text
                    outlined
                    style="margin: 10px 5px"
                    color="#125C99"
                    type="info"
                >
                    You may request an approval for your dependent by selecting them on the field below.
                </v-alert>
            </div>
            <v-select
                v-model="membN"
                label="NAME:"
                :items="getRelated && getRelated.PRIN_DEP"
                item-text="LAST_M"
                auto-select-first
                return-object
                color="teal"
                autocomplete="nope"
                :loading="loading.main"
                :disabled="loading.main"
                @change="handleChangeMemb"
            />
            <v-text-field
                label="SEX:"
                :value="getInfo.SEX"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="DATE OF BIRTH:"
                :value="getInfo.F_BIRTHDATE"
                color="teal"
                readonly
                autocomplete="nope"
            />
        </template>
    </FormCard>
</template>

<script>
import FormCard from './Other/FormCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { moment } from '../../../../utils/date-shim'

export default {
    components: {
        FormCard
    },
    props: ['to', 'req', 'member_model', 'isRequesting', 'loading'],
    data: ()=>({
        membN: null
    }),
    computed: {
        ...mapGetters(['getRelated', 'getUserConsultInfo']),
        getInfo: {
            get() {
                return {
                    SEX: this.getUserConsultInfo.SEX,
                    DOB: moment(this.getUserConsultInfo.DOB).utcOffset('+0800').format('DD MMMM YYYY'),
                    F_BIRTHDATE: this.getUserConsultInfo.F_BIRTHDATE
                }
            }
        }
    },
    watch: {
        getUserConsultInfo() {
            this.loading.main = false
        },
        member_model: {
            handler(newVal) {
                if (newVal) this.membN = newVal
            },
            deep: true,
            immediate: true
        },
        membN(newVal) {
            this.member_model.MEMB_N = newVal.MEMB_N
            this.member_model.LAST_M = newVal.LAST_M
        }
    },
    methods: {
        ...mapActions(['userConsult', 'toHospClin', 'reqHospClin']),
        handleChangeMemb() {
            this.to.facility = ''
            this.to.region = ''
            this.to.province = ''
            this.to.city = ''
            this.to.hospClinDoctor = ''
            this.to.hospClinType = 'H'
            this.to.decking = ''
            this.req.facility = ''
            this.req.facility = ''
            this.req.region = ''
            this.req.province = ''
            this.req.city = ''
            this.req.hospClinDoctor = ''
            this.req.hospClinType = 'H'
            this.req.decking = ''
            this.loading.main = true
            this.userConsult({ MEMBN: this.membN.MEMB_N })
            this.loading.hospital = true
            this.toHospClin({ REGION: this.to.region, PROVINCE: this.to.province, CITY: this.to.city, TYPE: '', MEMBN: this.membN.MEMB_N })
            this.reqHospClin({ REGION: this.req.region, PROVINCE: this.req.province, CITY: this.req.city, TYPE: '', MEMBN: this.membN.MEMB_N })
            this.$emit('changeIsReq', false)
        }
    }
}
</script>
